import Vue from "vue";
import Router from "vue-router";

const _import = require("./_import_components");

Vue.use(Router);

export default new Router({
  //后端支持可开
  mode: "history",
  routes: [
    {
      path: "/",
      component: _import("layout/index"),
      children: [
        {
          path: "/login",
          component: _import("layout/login"),
        },
        {
          path: "/forgetPwd",
          component: _import("layout/forgetPwd"),
        },
        {
          path: "/setPwd",
          component: _import("layout/setPwd"),
        },
        {
          path: "/signIn",
          component: _import("layout/signIn"),
        },
        {
          path: "/signUp",
          component: _import("layout/signUp"),
        },
        {
          path: "/dynamicRankBoard",
          component: _import("layout/dynamicRankBoard"),
        },
        {
          path: "/certificate",
          component: _import("layout/certificate"),
        },
        {
          path: "/learn",
          component: _import("layout/learn"),
        },
        {
          path: "/intro",
          component: _import("layout/intro"),
        },
        {
          path: "/raceCenter",
          component: _import("layout/raceCenter"),
        },
        {
          path: "/userIndex",
          component: _import("layout/userIndex"),
        },
        {
          path: "/final",
          component: _import("layout/finalIndex"),
        },
        {
          path: "/finalReg",
          component: _import("layout/finalReg"),
        },
        {
          path: "/finalRegEasymode",
          component: _import("layout/finalRegEasymode"),
        },
        {
          path: "/finalReport",
          component: _import("layout/finalReport"),
        },
        {
          path: "/finalTeacher",
          component: _import("layout/finalTeacher"),
        },

        {
          path: "/",
          component: _import("layout/compete-Pre"),
        },
      ],
    },

    {
      path: "/test",
      component: _import("test/index"),
      children: [
        {
          path: "/",
          component: _import("test/compete-Pre"),
        },
        {
          path: "/test/login",
          component: _import("test/login"),
        },
        {
          path: "/test/signUp",
          component: _import("test/signUp"),
        },
        {
          path: "/test/userIndex",
          component: _import("test/userIndex"),
        },
      ],
    },
    // 成都青羊区比赛
    {
      path: "/cdqy",
      component: _import("cdqy/index"),
      children: [
        {
          path: "/",
          component: _import("cdqy/compete-Pre"),
        },
        {
          path: "/cdqy/login",
          component: _import("cdqy/login"),
        },
        {
          path: "/cdqy/signUp",
          component: _import("cdqy/signUp"),
        },
        {
          path: "/cdqy/userIndex",
          component: _import("cdqy/userIndex"),
        },
      ],
    },

    {
      path: "/szxc",
      component: _import("szxc/index"),
      children: [
        {
          path: "/",
          name: "szxcCompete",
          component: _import("szxc/compete-Pre"),
        },
        {
          path: "/szxc/login",
          name: "szxcLogin",
          component: _import("szxc/login"),
        },
        {
          path: "/szxc/signUp",
          name: "szxcSignUp",
          component: _import("szxc/signUp"),
        },
        {
          path: "/szxc/userIndex",
          name: "szxcUserIndex",
          component: _import("szxc/userIndex"),
        },
      ],
    },
    {
      path: "/njgz",
      component: _import("njgz/index"),
      children: [
        {
          path: "/",
          component: _import("njgz/compete-Pre"),
        },
        {
          path: "/njgz/login",
          component: _import("njgz/login"),
        },
        {
          path: "/njgz/signUp",
          component: _import("njgz/signUp"),
        },
        {
          path: "/njgz/userIndex",
          component: _import("njgz/userIndex"),
        },
      ],
    },
    {
      path: "/ntcc",
      component: _import("ntcc/index"),
      children: [
        {
          path: "/",
          component: _import("ntcc/compete-Pre"),
        },
        {
          path: "/ntcc/login",
          component: _import("ntcc/login"),
        },
        {
          path: "/ntcc/signUp",
          component: _import("ntcc/signUp"),
        },
        {
          path: "/ntcc/userIndex",
          component: _import("ntcc/userIndex"),
        },
      ],
    },
    {
      path: "/wxfinal",
      component: _import("wxfinal/index"),
      children: [
        {
          path: "/",
          component: _import("wxfinal/compete-Pre"),
        },
        {
          path: "/wxfinal/login",
          component: _import("wxfinal/login"),
        },
        {
          path: "/wxfinal/rankboard",
          component: _import("wxfinal/rankboard"),
        },
        {
          path: "/wxfinal/userIndex",
          component: _import("wxfinal/userIndex"),
        },
      ],
    },
    {
      path: "/wtsxx",
      component: _import("wtsxx/index"),
      children: [
        {
          path: "/",
          component: _import("wtsxx/compete-Pre"),
        },
        {
          path: "/wtsxx/login",
          component: _import("wtsxx/login"),
        },
        {
          path: "/wtsxx/rankboard",
          component: _import("wtsxx/rankboard"),
        },
        {
          path: "/wtsxx/userIndex",
          component: _import("wtsxx/userIndex"),
        },
      ],
    },
    {
      path: "/njsq",
      component: _import("njsq/index"),
      children: [
        {
          path: "/",
          component: _import("njsq/compete-Pre"),
        },
        {
          path: "/njsq/login",
          component: _import("njsq/login"),
        },
        {
          path: "/njsq/userIndex",
          component: _import("njsq/userIndex"),
        },
      ],
    },
    {
      path: "/shoi",
      component: _import("shoi/index"),
      children: [
        {
          path: "/",
          component: _import("shoi/login"),
        },
        {
          path: "/shoi/userIndex",
          component: _import("shoi/userIndex"),
        },
      ],
    },
    {
      path: "/xasq",
      component: _import("xasq/index"),
      children: [
        {
          path: "/",
          component: _import("xasq/compete-Pre"),
        },
        {
          path: "/xasq/login",
          component: _import("xasq/login"),
        },
        {
          path: "/xasq/userIndex",
          component: _import("xasq/userIndex"),
        },
      ],
    },
    {
      path: "/jxcs",
      component: _import("jxcs/index"),
      children: [
        {
          path: "/",
          component: _import("jxcs/compete-Pre"),
        },
        {
          path: "/jxcs/login",
          component: _import("jxcs/login"),
        },
        {
          path: "/jxcs/userIndex",
          component: _import("jxcs/userIndex"),
        },
      ],
    },
    {
      path: "/qdqtz",
      component: _import("qdqtz/index"),
      children: [
        {
          path: "/",
          component: _import("qdqtz/compete-Pre"),
        },
        {
          path: "/qdqtz/login",
          component: _import("qdqtz/login"),
        },
        {
          path: "/qdqtz/userIndex",
          component: _import("qdqtz/userIndex"),
        },
      ],
    },

    {
      path: "/israel",
      component: _import("israel/index"),
      children: [
        {
          path: "/",
          component: _import("israel/compete-Pre"),
        },
        {
          path: "/israel/login",
          component: _import("israel/login"),
        },
        {
          path: "/israel/userIndex",
          component: _import("israel/userIndex"),
        },
      ],
    },

    {
      path: "/404",
      name: "t404",
      component: () => import("../components/common/t404.vue"),
    },

    {
      path: "*",
      redirect: "/404",
    },
  ],

  scrollBehavior: () => ({
    y: 0,
  }),
});



// WEBPACK FOOTER //
// ./src/router/index.js